//
// Shared constants for use throughout the Study Recruitment Service & Components
//

/**
 * Names of Flags to be used to determine when API calls are in
 * progress or not.
 *
 * Note: There should be one name unique to each API call.
 */
export const LOADER_TYPES = {
  STUDY_RECRUITMENT_DATA: "studyRecruitmentData",
  SAVE_STUDY_RECRUITMENT_DATA: "saveStudyRecruitmentData",
  STUDY_RECRUITMENT_METRICS: "studyRecruitmentMetrics",
  STUDIES: "studies",
  OUTREACH_COHORTS: "outreachCohorts",
  UPDATE_OUTREACH_COHORT_STATUS: "updateOutreachCohortStatus",
};

export const INSTRUCTIONS_LINKS = {
  SMCT: "https://med.stanford.edu/clinicaltrials",
  SM: "https://stanfordhealthcare.org",
  SPES: "https://med.stanford.edu/spectrum/researcher-resources/participant-engagement.html",
  NIHCT: "https://clinicaltrials.gov/",
  EMAIL: "mailto:EngageParticipants@stanford.edu",
};

export const OUTREACH_EMAIL =
  "mailto:spectrum_services_support@lists.stanford.edu";

export const INFO_DIALOG_KEYS = {
  PEP_RECRUITMENT: "pepRecruitment",
  STANFORD_CLINICAL_TRIALS_DIRECTORY: "stanfordClinicalTrialsDirectory",
  STUDY_RECRUITMENT_CONTACT: "studyRecruitmentContact",
  OFFICIAL_STUDY_TITLE: "officialStudyTitle",
  STUDY_TITLE: "studyTitle",
  PURPOSE: "purpose",
  INCLUSION_CRITERIA: "inclusionCriteria",
  EXCLUSION_CRITERIA: "exclusionCriteria",
  PRE_SCREEING_QUESTIONNAIRE: "prescreeningQuestionnaire",
};

export const METRICS_STATUS_LABELS = {
  NEW: "new",
  IRB_INITIAL_APPROVAL: "irbInitialApproval",
  IRB_STUDY_CLOSURE: "irbStudyClosure",
  OPEN_TO_ACCRUAL: "openToAccrual",
  CLOSED_TO_ACCRUAL: "closedToAccrual",
  SUSPENDED: "suspended",
  TERMINATED: "terminated",
  ON_HOLD: "onHold",
  ABANDONED: "abandoned",
  SRC_OR_CRU_APPROVAL: "srcOrCruApproval",
  READY_TO_ACTIVATE_SIGNOFF: "readyToActivateSignoff",
  UNRECOGNIZED: "unrecognized",
  STATUS_NOT_LISTED: "statusNotListed",
  NOT_YET_RECRUITING: "notYetRecruiting",
  RECRUITING: "recruiting",
  NOT_RECRUITING: "notRecruiting",
  STUDY_COMPLETE: "studyComplete",
  INACTIVE: "inactive",
  ACTIVE: "ACTIVE",
};

export const COHORT_STUDY_RECRUITMENT_STATUS = {
  START: "START",
  STOP: "STOP",
  PAUSE: "PAUSE",
  RESUME: "RESUME",
  NOT_STARTED: "NOT_STARTED",
  ABORTED: "ABORTED",
};
